(function () {
  var script = document.currentScript;
  if (script.dataset.loggedOut === 'true') {
    window.location.href = '/account/login?return_url=' + encodeURIComponent('/pages/my-account-order' + window.location.search);
    return;
  }

  document.addEventListener('DOMContentLoaded', function () {
    var params = new URLSearchParams(window.location.search);
    var orderId = params.get('id');
    if (orderId) {
      var el = document.querySelector('[data-order-id="' + orderId + '"]');
      if (el) { el.removeAttribute('hidden'); return; }
    }
    var notFound = document.getElementById('order-not-found');
    if (notFound) notFound.removeAttribute('hidden');
  });
})();
